export default __webpack_public_path__ + "static/media/mypic.94829b52.png";